import { Creative } from './types';

type ThumbnailStatus = Creative['thumbnailStatus'];

export const CREATIVES_PENDING_STATUSES: ThumbnailStatus[] = ['PROCESSING', 'UNKNOWN'];
